var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsFacebookGrayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_sns_facebook_gray_filled_svg__clip0_37861_449410)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.074 6.122H21.01c-2.031 0-2.665 1.342-2.665 2.717v3.262h4.539l-.726 5.03h-3.813v12.157c-1.694.283-3.42.283-5.115 0V17.13H9.075V12.1h4.154V8.27c0-4.361 2.443-6.769 6.182-6.769 1.79 0 3.663.34 3.663.34v4.282z",
    fill: props.color
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_sns_facebook_gray_filled_svg__clip0_37861_449410"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconSnsFacebookGrayFilled;